import React from "react";

import { IAttributeHeaderProps } from "components/dashboard/product-template-table/utils/cellInterfaces";
import Header from "./header";

export default function AttributeHeader(props: IAttributeHeaderProps) {
  return (
    <Header
      displayName={props.attribute.displayName}
      referenceName={props.attribute.referenceName}
      description={props.attribute.description}
      noTh={props.noTh}
    />
  );
}



